import React from 'react';

import BodyStyle from './body';

// Ant Design component style overrides specific to the company app.
const Overrides = () => <BodyStyle />;

export default Overrides;
